



































import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import * as _ from "lodash";
import { integer } from "vee-validate/dist/rules";
import {inventoryCollection} from "../../db";

@Component({})
export default class Hacks extends Vue {
  @Getter inventory;

  private duplicatedOrderIds: Array<number> = [];

  @Watch("inventory", { immediate: true })
  inventoryUpdated() {
    this.findDuplicatedOrders();
  }

  findDuplicatedOrders() {
    this.duplicatedOrderIds = [];
    const orders = _.countBy(this.inventory, "order");
    for (const key in orders) {
      if (orders[key] > 1) {
        this.duplicatedOrderIds.push(Number.parseInt(key));
      }
    }
  }

  async fixInventoryOrders() {
    for (const order of this.duplicatedOrderIds) {
      const duplicates = _.filter(this.inventory, (x) => x.order == order);
      for (let i = 0; i < duplicates.length; i++) {
        const item = duplicates[i];
        if (i > 0) {
          await this.fixOrder(item);
        }
      }
    }

    this.findDuplicatedOrders();
  }

  async fixOrder(item) {
    // find new order number
    const minOrderEquipment: any = _.minBy(this.inventory, (x: any) => x.order );
    const minOrder = Number.parseInt(minOrderEquipment.order);

    await inventoryCollection.doc(`${item.id}`).update({order: minOrder - 1});
  }
}
